const CLOCK_ENABLED_DATETIME_FIELDS = new Set(["datein", "edd"]);

export const normalizeAttributeKey = (value?: string | null): string =>
  (value || "").toLowerCase().replace(/[^a-z0-9]/g, "");

export const isDateTimeWithClockField = (
  attributeName?: string | null,
  attributeLabel?: string | null
): boolean => {
  const normalizedName = normalizeAttributeKey(attributeName);
  const normalizedLabel = normalizeAttributeKey(attributeLabel);

  return (
    CLOCK_ENABLED_DATETIME_FIELDS.has(normalizedName) ||
    CLOCK_ENABLED_DATETIME_FIELDS.has(normalizedLabel)
  );
};
